/**
 * Eine feste Farbe je Mandant — abgeleitet aus dem Kürzel.
 *
 * Ticket #11 (Marlene, 20.08.2026): „vllt können wir iwie farblich noch mehr
 * erkenntlich machen, in welchem Tenant man sich gerade befindet".
 *
 * Bewusst **abgeleitet statt konfiguriert**: eine Farbe je Mandant wäre ein
 * weiteres Feld, das jemand pflegen müsste und das bei einem neuen Mandanten
 * leer bliebe — ausgerechnet dann, wenn die Verwechslungsgefahr am größten ist.
 * So bekommt jeder Mandant sofort eine, und sie bleibt über Sitzungen und
 * Rechner hinweg dieselbe.
 *
 * Das ist mehr als Kosmetik: im falschen Mandanten zu arbeiten fällt oft erst
 * auf, nachdem etwas angelegt wurde.
 */

/** Stabiler Hash über die Zeichen — gleiche Eingabe, gleiche Farbe, immer. */
function hash(text: string): number {
  let h = 0
  for (let i = 0; i < text.length; i++) {
    h = (h << 5) - h + text.charCodeAt(i)
    h |= 0
  }
  return Math.abs(h)
}

export type TenantFarbe = {
  rand: string
  hintergrund: string
  text: string
  /** Vollflächiger dunkler Anstrich für die Sidebar (#60): dunkel genug für
   *  helle Schrift, kräftig genug, dass das GANZE Menü die Farbe trägt. */
  flaeche: string
  /** Hellere Variante desselben Tons für den Verlauf nach oben. */
  flaecheHell: string
}

/**
 * Farbe für ein Mandanten-Kürzel. Leeres Kürzel = „alle Mandanten" → neutral.
 *
 * Sättigung und Helligkeit sind fest: nur der Farbton wandert. Damit sind alle
 * Mandantenfarben gleich kräftig und keine verschwindet auf hellem Grund.
 */
export function tenantFarbe(slug?: string | null): TenantFarbe | null {
  const s = (slug || "").trim()
  if (!s) return null
  const ton = hash(s) % 360
  return {
    rand: `hsl(${ton} 65% 45%)`,
    hintergrund: `hsl(${ton} 65% 45% / 0.14)`,
    text: `hsl(${ton} 70% 30%)`,
    flaeche: `hsl(${ton} 45% 16%)`,
    flaecheHell: `hsl(${ton} 50% 24%)`,
  }
}
